import styled from 'styled-components';

const media = {
  mobile: '@media (max-width: 768px)',
  tablet: '@media (max-width: 1024px)',
  smallMobile: '@media (max-width: 480px)',
};

// Container principal da tela
export const ScreenContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow-x: hidden;
`;

// Área com scroll (tudo menos o footer)
export const ScrollableArea = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
`;

// Header
export const HeaderBenefits = styled.div`
  display: flex;
  flex-shrink: 0;
  min-height: 320px;
  padding: 8px;
  flex-direction: column;
  background: linear-gradient(
      360deg,
      #191919 -86.67%,
      rgba(25, 25, 25, 0.5) -3.33%,
      rgba(25, 25, 25, 0) 73.33%
    ),
    url(/assets/backgroundBenefit.png);
  background-size: cover;
  background-position: center;
  position: relative;
  z-index: 1;

  ${media.mobile} {
    min-height: 250px;
    padding: 1.5rem;
  }
`;

// Container do vídeo - posicionado para sair do header
export const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 560px;
  margin: -160px auto 0; /* Metade do vídeo dentro do header */
  padding:  0 8px;
  z-index: 10;

  iframe {
    width: 100%;
    height: 315px;
    border: none;
    border-radius: 1rem;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  }

  ${media.mobile} {
    max-width: 90%;
    margin: -120px auto 0;

    iframe {
      height: 250px;
    }
  }

  ${media.smallMobile} {
    margin: -100px auto 0;

    iframe {
      height: 200px;
    }
  }
`;

// Main - começa após o vídeo
export const Main = styled.main`
  padding: 24px;
  position: relative;
  z-index: 1;

  ${media.mobile} {
    padding: 1.5rem;
  }

  ${media.smallMobile} {
    padding: 1rem;
  }
`;

// Footer fixo
export const Footer = styled.footer`
  position: sticky;
  bottom: 0;
  background: #fff;
  padding: 1rem 2rem;
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  align-items: center;
  border-top: 1px solid #e0e0e0;
  z-index: 100;

  ${media.mobile} {
    padding: 1rem 1.5rem;
  }
`;

// Outros componentes que você já tinha
export const Subtitle = styled.div`
  padding: 24px;
`;
export const CloseBenefits = styled.div`
  height: 2rem;
  display: flex;
  align-items: center;
  padding: 24px;
  justify-content: space-between;

  span {
    color: #fff;
    cursor: pointer;
    stroke-width: 3rem;
    font-size: 16px;
  }

  ${media.mobile} {
    padding: 1.5rem 1.5rem 1rem;

    span {
      font-size: 14px;
    }
  }
`;

export const InfosBenefits = styled.div`
  gap: 0.5rem;
  display: flex;
  align-items: center;
`;
